<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group row">
            <div class="col-md-12">
                <yt-fw-date-picker-popup
                formControlName="DatumOd"
                name="txtDatum" 
                [Label]="'VAZECIPROCENATZARADE.DATUM.SINGULAR'">                    
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.DatumOd.invalid">
                    <span *ngFor="let validation of errorMessages.DatumOd">
                      <span class="error-message" *ngIf="fc.DatumOd.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
                <label class="col-form-label col-md-6 pr-0">                   
                    <span translate="VAZECIPROCENATZARADE.PROCENATPLATNIPROMET.SINGULAR"></span>
                  </label>                
                <yt-number-input-v2
                formControlName="ProcenatPlatniPromet"
                name="txtProcenatPlatniPromet">
              </yt-number-input-v2> 
              <!-- <yt-input
                [Type]="'text'"
                name="txtProcenatPlatniPromet"
                formControlName="ProcenatPlatniPromet"
                #focusElement
                [ngClass]="{'is-invalid' : submitted && fc.ProcenatPlatniPromet.invalid}"
                [Label]="'VAZECIPROCENATZARADE.PROCENATPLATNIPROMET.SINGULAR'"
                [Uppercase]="true">
              </yt-input> -->
                <div class="form-error" *ngIf="submitted && fc.ProcenatPlatniPromet.invalid">
                    <span *ngFor="let validation of errorMessages.ProcenatPlatniPromet">
                      <span class="error-message" *ngIf="fc.ProcenatPlatniPromet.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
                <label class="col-form-label col-md-6 pr-0">                   
                    <span translate="VAZECIPROCENATZARADE.PROCENATWESTERNUNION.SINGULAR"></span>
                  </label>                
                <yt-number-input-v2
                formControlName="ProcenatWesternUnion"
                name="txtProcenatWesternUnion">
              </yt-number-input-v2> 
              <!-- <yt-input
                [Type]="'text'"
                name="txtProcenatWesternUnion"
                formControlName="ProcenatWesternUnion"
                [ngClass]="{'is-invalid' : submitted && fc.ProcenatWesternUnion.invalid}"
                [Label]="'VAZECIPROCENATZARADE.PROCENATWESTERNUNION.SINGULAR'">
              </yt-input> -->
                <div class="form-error" *ngIf="submitted && fc.ProcenatWesternUnion.invalid">
                    <span *ngFor="let validation of errorMessages.ProcenatWesternUnion">
                      <span class="error-message" *ngIf="fc.ProcenatWesternUnion.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
          </div>
  
        </div>
      </div>
    </div>
  </form>
  